import { render } from "./updatepassword.vue?vue&type=template&id=1102acc8"
import script from "./updatepassword.vue?vue&type=script&lang=js"
export * from "./updatepassword.vue?vue&type=script&lang=js"

import "./updatepassword.vue?vue&type=style&index=0&id=1102acc8&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__